import { VehicleFilterForm, VehicleFilterFormProps } from '~/components/vehicle-filter-form';

export function MsVehicleFilterForm(props: VehicleFilterFormProps) {
  return <VehicleFilterForm {...props} />;
}
